export default "__VITE_ASSET__DTkj3l7a__"